/* @flow */

import { asyncWrapper } from './async';
import { DatasetConstants } from '../constants/dataset_constants';
import { DatasetSelectors } from './dataset_selectors';
import * as APIClient from '../util/api_client';

var DatasetActionCreators = {
  loadDatasetById: function(ownerId: string, datasetId: string, loadingType: LoadingType): Function {
    return (dispatch, getState) => {
      if (!DatasetSelectors.getDatasetStatus(getState(), ownerId, datasetId)) {
        dispatch({
          type: DatasetConstants.DATASET_SET_STATUS,
          ownerId,
          datasetId,
          status: 'loading'
        });
        return asyncWrapper(APIClient.datasetLoad(ownerId, datasetId).then((dataset) => {
          dispatch({
            type: DatasetConstants.DATASET_LOAD,
            ownerId,
            datasetId,
            features: dataset.features
          });
        }), loadingType, dispatch);
      }
    };
  },
};

export { DatasetActionCreators };
